import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import { ReportActionActionName } from '@amzn/handshake-painter-typescript-client/v1';
import { PrimeButton, OrangeButton } from 'src/common/buttons';
import { usePageContext, useAppInit, useReportAction } from 'src/hooks';
import { sendAuthMessage } from 'src/utils/messages';
import { AuthStatus } from 'src/utils/auth';
import { useAnalyticsContext } from 'src/common/metrics/AnalyticsContext';
import { routes } from 'src/utils/routes';
import { addProductDetailsToBag } from 'src/utils/bagUtils';
import { getExperimentArm, getOneClickArm } from 'src/utils/experiments';
export const ContinueButton = ({ isDisabled, quantity, isPrime, product, source, dataTestId, onOneClickCheckout, }) => {
    const { bundle } = usePageContext();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const rumClient = useAnalyticsContext();
    const { data: appData } = useAppInit();
    const isUserLinked = !!(appData === null || appData === void 0 ? void 0 : appData.linked);
    const { mutate: reportAction } = useReportAction();
    const Button = isPrime ? PrimeButton : OrangeButton;
    // WEBLAB_PAINTER_PDP_BUY_CTA: T1 = "Buy with Prime"/"Buy now"; C = "Continue with Prime"/"Continue with Amazon".
    const isBuyCtaEnabled = getExperimentArm(appData === null || appData === void 0 ? void 0 : appData.experiments, 'WEBLAB_PAINTER_PDP_BUY_CTA') === 'T1';
    let ctaMessageKey;
    if (isBuyCtaEnabled) {
        ctaMessageKey = isPrime ? 'buyWithPrime' : 'buyNow';
    }
    else {
        ctaMessageKey = isPrime ? 'continueWithPrime' : 'continueWithAmazon';
    }
    const onContinueClick = () => {
        // Do we throw or console.error?
        if (!product) {
            throw new Error('Product details missing.');
        }
        // Report button click action
        reportAction({
            actionName: ReportActionActionName.BuyButtonClick,
            source,
        });
        // Emit an arm-tagged RUM event so the buy-CTA click rate can be split by
        // WEBLAB_PAINTER_PDP_BUY_CTA control vs treatment (the backend BuyButtonClick
        // action report above is label-independent and not arm-aware).
        // oneClickArm splits the 1-Click funnel's Buy now clicks by arm, matching ACCESS_TO_PAINTER_2's tag
        rumClient.recordEvent('PDP_BUY_CTA_CLICK', {
            arm: isBuyCtaEnabled ? 'T1' : 'C',
            oneClickArm: getOneClickArm(appData === null || appData === void 0 ? void 0 : appData.experiments),
            isPrime,
        });
        // Add current product to bag
        addProductDetailsToBag(product, quantity);
        // TODO: Prefetch previewOrder API, add spinner to button, navigate on success or handle error appropriately
        const previewPage = `${routes.previewOrderPage}?${searchParams.toString()}`;
        if (onOneClickCheckout) {
            onOneClickCheckout();
        }
        else if (isUserLinked) {
            navigate(previewPage);
        }
        else {
            sendAuthMessage(rumClient, AuthStatus.AUTHENTICATE, previewPage, source);
        }
    };
    return (_jsx(Button, { disabled: isDisabled, onClick: onContinueClick, "data-testid": dataTestId, children: bundle.getMessage(ctaMessageKey) }));
};
